"use client";

import {
  CheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
  XIcon,
} from "lucide-react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group font-sans"
      icons={{
        success: <CheckIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
        close: <XIcon className="size-4" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "group font-sans toast card flex gap-2 px-4 py-3 min-h-12 text-sm",
          description: "group-[.toast]:text-muted-foreground",
          title: "group-[.toast]:font-medium",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:border-primary group-[.toast]:shadow-sm group-[.toast]:rounded-md group-[.toast]:border group-[.toast]:font-medium",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:border-border group-[.toast]:shadow-sm group-[.toast]:rounded-md group-[.toast]:border group-[.toast]:font-medium",
          success: "card-success",
          error: "card-critical",
          warning: "card-warn",
          content: "flex justify-center flex-col",
          icon: "mt-0.5",
          closeButton:
            "group-[.toast]:border-border group-[.toast]:bg-transparent group-[.toast]:hover:bg-accent group-[.toast]:rounded-md",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
